<template>
    <div id="partners">
        <section id="partners-section">
            <div class="container my-5">
                <div class="row justify-content-center text-center">
                    <div class="col-12">
                        <div class="intro-message"  data-aos="fade-up" data-aos-duration="1200">
                            <span class="section-title mb-1">You Can Find Our Tech In:</span>
                            <span class="section-title sub-title mb-5">Enterprises. Corporates. Start-Ups.</span>
                            <carousel
                                    :autoplay="true"
                                    :loop="true"
                                    :perPage="1"
                                    :paginationEnabled="false"
                                    :navigationEnabled="false"
                                    :scrollPerPage="true"
                            >
                                <slide v-for="(partner, i) in partners" :key="i">
                                  <a rel="noopener" v-if="partner.link" :aria-label="partner.title" class="link" target="_blank" :href="partner.link" >
                                    <img itemprop="image" class="img-fluid d-block m-auto pt-4 company-image" :alt="partner.title" :src="partner.image">
                                    <p class="company-name">{{partner.title}}</p>
                                  </a>
                                  <div v-else>
                                    <img itemprop="image" class="img-fluid d-block m-auto pt-4 company-image" :alt="partner.title" :src="partner.image">
                                    <p class="company-name">{{partner.title}}</p>
                                  </div>
                                </slide>
                            </carousel>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        name: 'partners',
        data () {
          return {
              partners: [
                    {image: 'img/partners/check-point.svg', title: 'Inspirational Enterprises'},
                    {image: 'img/partners/willyou.svg', title: 'Successful companies'},
                    {image: 'img/partners/perpage.svg', title: 'Revolutionary Start-ups'},
                    {image: 'img/partners/probeauty.svg', title: 'Revolutionary Start-ups'},
                    {image: 'img/partners/uwork.svg', title: 'Successful companies'},
                    {image: 'img/partners/wroti.svg', title: 'Revolutionary Start-ups'},
                    {image: 'img/partners/chunk.svg', title: 'Revolutionary Start-ups'},
              ],
          }
        },
        components: {
            Carousel,
            Slide,
        },
    }
</script>

<style lang="css" scoped>
    #partners-section {
        background-color: #fff;
        color: #000000;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .section-title {
        font-size: 35px;
        font-weight: 300;
        line-height: 1;
        width: 100%;
        display: block;
        text-align: center;
    }
    .sub-title {
        font-size: 20px;
        margin-bottom: 50px;
    }
    .intro-message {
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .company-name {
        font-size: 30px;
        margin-top: 50px;
    }
    .link{
        color: #000 !important;
        text-decoration: none;
    }
    .company-image {
        width: 350px;
    }

    @media (max-width: 767px) {
        .section-title {
            font-size: 30px;
        }
        .sub-title {
            font-size: 18px;
        }
    }
</style>
